<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "BrandSimilarTags" });
import { TagList } from "../../../../selects/index.js";
import * as API from "../../services/api.js";
export let keys = [];
export let isDisabled = false;
export let minItems = 0;
export let maxItems = 1e3;
export let parameters = null;
export let label = "You may be interested in these brands as well:";
export let mode = "add";
const setLabel = (brand) => ({ key: brand._.key, label: brand.name });
const format = (brands) => brands.map(setLabel);
let previousParams = "";
let options = [];
const fetchBrands = (parameters2) => {
    if (keys.length === 0 || parameters2 === null) {
        return;
    }
    const CURRENT_PARAMS = JSON.stringify(parameters2);
    if (CURRENT_PARAMS === previousParams) {
        return;
    }
    void API.filterBrands(parameters2).then((brands) => {
        options = [];
        previousParams = CURRENT_PARAMS;
        if (Array.isArray(brands) && brands.length > 0) {
            options = format(brands);
        }
    });
};
$: fetchBrands(parameters);
</script>

{#if keys.length > 0}
    <TagList
        bind:keys
        name = 'category.keys'
        { options }
        { label }
        { minItems }
        { maxItems }
        { isDisabled }
        { mode }
    />
{/if}